export default {
      id: "telephone-usage",
      viewBox: "0 0 23 23",
      url: "/" + "sprite.svg#telephone",
      toString: function () {
        return this.url;
      }
    }